import useScrollAnimation from '../../../hooks/useScrollAnimation';

const FaqContact = () => {
  const { ref: sectionRef, isVisible } = useScrollAnimation({ threshold: 0.1 });

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;

    const textarea = form.querySelector('textarea');
    if (textarea && textarea.value.length > 500) {
      return;
    }

    const nombre = (form.querySelector('#faq-nombre') as HTMLInputElement)?.value || '';
    const email = (form.querySelector('#faq-email') as HTMLInputElement)?.value || '';
    const telefono = (form.querySelector('#faq-telefono') as HTMLInputElement)?.value || '';
    const asunto = (form.querySelector('#faq-asunto') as HTMLSelectElement)?.value || '';
    const mensaje = (form.querySelector('#faq-mensaje') as HTMLTextAreaElement)?.value || '';

    const whatsappMsg = `Hola, tengo una consulta desde la web de Desguace Gavá.

👤 *Datos de contacto:*
• Nombre: ${nombre}${email ? `\n• Email: ${email}` : ''}${telefono ? `\n• Teléfono: ${telefono}` : ''}

📋 *Asunto:* ${asunto}

💬 *Mensaje:*
${mensaje}`;

    const url = `https://wa.me/34932932913?text=${encodeURIComponent(whatsappMsg)}`;
    window.open(url, '_blank');

    form.reset();
    const successEl = document.getElementById('faq-form-success');
    if (successEl) {
      successEl.classList.remove('hidden');
      setTimeout(() => successEl.classList.add('hidden'), 5000);
    }
  };

  return (
    <section className="py-20 px-6 lg:px-12 bg-white">
      <div ref={sectionRef} className="max-w-7xl mx-auto">
        <div
          className={`bg-emerald-50 rounded-3xl overflow-hidden transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
          }`}
        >
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <div
              className={`p-10 lg:p-14 flex flex-col justify-center transition-all duration-700 delay-200 ${
                isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'
              }`}
            >
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                ¿No encuentras tu respuesta?
              </h2>
              <p className="text-gray-600 leading-relaxed mb-8">
                Envíanos tu consulta y nuestro equipo de <strong>Desguace Gavá</strong> te responderá en menos de 2 horas. También puedes contactarnos directamente por teléfono o WhatsApp.
              </p>

              <div className="space-y-4 mb-8">
                <a href="tel:+34932932913" className="flex items-center space-x-3 text-gray-700 hover:text-emerald-600 transition-colors cursor-pointer">
                  <div className="w-10 h-10 bg-emerald-600 rounded-lg flex items-center justify-center">
                    <i className="ri-phone-fill text-white"></i>
                  </div>
                  <div>
                    <p className="text-sm font-bold">Teléfono</p>
                    <p className="text-sm text-gray-500">932 932 913</p>
                  </div>
                </a>
                <a href="https://wa.me/34932932913" target="_blank" rel="nofollow noopener noreferrer" className="flex items-center space-x-3 text-gray-700 hover:text-emerald-600 transition-colors cursor-pointer">
                  <div className="w-10 h-10 bg-emerald-600 rounded-lg flex items-center justify-center">
                    <i className="ri-whatsapp-fill text-white"></i>
                  </div>
                  <div>
                    <p className="text-sm font-bold">WhatsApp</p>
                    <p className="text-sm text-gray-500">Respuesta inmediata</p>
                  </div>
                </a>
                <div className="flex items-center space-x-3 text-gray-700">
                  <div className="w-10 h-10 bg-emerald-600 rounded-lg flex items-center justify-center">
                    <i className="ri-time-fill text-white"></i>
                  </div>
                  <div>
                    <p className="text-sm font-bold">Horario</p>
                    <p className="text-sm text-gray-500">L-V: 9-19h | S: 9-14h</p>
                  </div>
                </div>
                <div className="flex items-center space-x-3 text-gray-700">
                  <div className="w-10 h-10 bg-emerald-600 rounded-lg flex items-center justify-center">
                    <i className="ri-map-pin-fill text-white"></i>
                  </div>
                  <div>
                    <p className="text-sm font-bold">Ubicación</p>
                    <p className="text-sm text-gray-500">Gavá, Barcelona</p>
                  </div>
                </div>
              </div>
            </div>

            <div
              className={`p-10 lg:p-14 bg-white rounded-3xl m-4 transition-all duration-700 delay-300 ${
                isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'
              }`}
            >
              <h3 className="text-xl font-bold text-gray-900 mb-6">Envíanos tu consulta</h3>

              <div id="faq-form-success" className="hidden mb-4 bg-emerald-50 border border-emerald-200 text-emerald-700 px-4 py-3 rounded-lg text-sm">
                <i className="ri-check-line mr-2"></i>Se ha abierto WhatsApp con tu consulta. ¡Gracias!
              </div>

              <form
                id="faq-contact-form"
                onSubmit={handleSubmit}
                className="space-y-4"
              >
                <div>
                  <label htmlFor="faq-nombre" className="block text-sm font-medium text-gray-700 mb-1">Nombre</label>
                  <input id="faq-nombre" name="nombre" type="text" required placeholder="Tu nombre" className="w-full px-4 py-3 rounded-lg border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent" />
                </div>
                <div>
                  <label htmlFor="faq-email" className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                  <input id="faq-email" name="email" type="email" required placeholder="tu@email.com" className="w-full px-4 py-3 rounded-lg border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent" />
                </div>
                <div>
                  <label htmlFor="faq-telefono" className="block text-sm font-medium text-gray-700 mb-1">Teléfono</label>
                  <input id="faq-telefono" name="telefono" type="tel" placeholder="Tu teléfono (opcional)" className="w-full px-4 py-3 rounded-lg border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent" />
                </div>
                <div>
                  <label htmlFor="faq-asunto" className="block text-sm font-medium text-gray-700 mb-1">Asunto</label>
                  <select id="faq-asunto" name="asunto" required className="w-full px-4 py-3 rounded-lg border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent bg-white cursor-pointer">
                    <option value="">Selecciona un asunto</option>
                    <option value="Vender mi coche">Vender mi coche</option>
                    <option value="Documentación y trámites">Documentación y trámites</option>
                    <option value="Precios y valoración">Precios y valoración</option>
                    <option value="Piezas de recambio">Piezas de recambio</option>
                    <option value="Recogida y grúa">Recogida y grúa</option>
                    <option value="Otro">Otro</option>
                  </select>
                </div>
                <div>
                  <label htmlFor="faq-mensaje" className="block text-sm font-medium text-gray-700 mb-1">Mensaje</label>
                  <textarea id="faq-mensaje" name="mensaje" required maxLength={500} rows={4} placeholder="Describe tu consulta..." className="w-full px-4 py-3 rounded-lg border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent resize-none"></textarea>
                  <p className="text-xs text-gray-400 mt-1">Máximo 500 caracteres</p>
                </div>
                <button type="submit" className="w-full bg-green-500 hover:bg-green-600 text-white py-3.5 rounded-lg font-semibold text-sm transition-all hover:scale-[1.02] whitespace-nowrap cursor-pointer flex items-center justify-center gap-2">
                  <i className="ri-whatsapp-line text-lg"></i>
                  Enviar por WhatsApp
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FaqContact;
